document.addEventListener('DOMContentLoaded', () => {

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll progress bar ---------- */
  const scrollProgress = document.getElementById('scrollProgress');
  if (scrollProgress) {
    const updateProgress = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      scrollProgress.style.width = `${pct}%`;
    };
    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
  }

  /* ---------- Hero particle field ---------- */
  const particleField = document.getElementById('particleField');
  if (particleField && !prefersReducedMotion) {
    const count = window.innerWidth < 700 ? 12 : 26;
    for (let i = 0; i < count; i++) {
      const p = document.createElement('span');
      const left = Math.random() * 100;
      const duration = 8 + Math.random() * 10;
      const delay = Math.random() * 12;
      const drift = (Math.random() * 60 - 30).toFixed(0) + 'px';
      const size = (2 + Math.random() * 2).toFixed(1) + 'px';
      p.style.left = `${left}%`;
      p.style.width = size;
      p.style.height = size;
      p.style.setProperty('--drift', drift);
      p.style.animationDuration = `${duration}s`;
      p.style.animationDelay = `${delay}s`;
      particleField.appendChild(p);
    }
  }

  /* ---------- Hero spotlight follows cursor ---------- */
  const heroSection = document.getElementById('heroSection');
  const heroSpotlight = document.getElementById('heroSpotlight');
  if (heroSection && heroSpotlight && !prefersReducedMotion) {
    heroSection.addEventListener('mousemove', (e) => {
      const rect = heroSection.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      heroSpotlight.style.setProperty('--x', `${x}%`);
      heroSpotlight.style.setProperty('--y', `${y}%`);
    });
  }

  /* ---------- Product stage: auto-cycling showcase ---------- */
  const stage = document.getElementById('productStage');
  if (stage) {
    const bottles = Array.from(stage.querySelectorAll('.stage-bottle'));
    const dots = Array.from(stage.querySelectorAll('.stage-dot'));
    const nameEl = document.getElementById('stageName');
    const tagEl = document.getElementById('stageTag');
    const reflection = document.getElementById('stageReflection');
    const glowPulse = document.getElementById('stageGlowPulse');
    let current = 0;
    let timer = null;
    const INTERVAL = 4800;

    function setReflection(img) {
      if (reflection) reflection.style.setProperty('--reflect-img', `url("${img.getAttribute('src')}")`);
    }

    function goTo(index) {
      if (index === current) return;
      bottles[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      dots[current] && dots[current].setAttribute('aria-selected', 'false');

      current = index;
      const active = bottles[current];
      active.classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
      dots[current] && dots[current].setAttribute('aria-selected', 'true');

      if (nameEl) nameEl.textContent = active.getAttribute('data-name') || '';
      if (tagEl) tagEl.textContent = active.getAttribute('data-tag') || '';
      setReflection(active);

      if (glowPulse && !prefersReducedMotion) {
        glowPulse.style.animation = 'none';
        void glowPulse.offsetWidth;
        glowPulse.style.animation = '';
      }
    }

    function next() { goTo((current + 1) % bottles.length); }

    function startAutoplay() {
      if (prefersReducedMotion) return;
      stopAutoplay();
      timer = setInterval(next, INTERVAL);
    }
    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }

    if (bottles[0]) {
      if (bottles[0].complete) setReflection(bottles[0]);
      else bottles[0].addEventListener('load', () => setReflection(bottles[0]), { once: true });
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { goTo(i); startAutoplay(); });
    });

    stage.addEventListener('mouseenter', stopAutoplay);
    stage.addEventListener('mouseleave', startAutoplay);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay(); else startAutoplay();
    });

    startAutoplay();

    if (!prefersReducedMotion && window.innerWidth > 900) {
      stage.addEventListener('mousemove', (e) => {
        const rect = stage.getBoundingClientRect();
        const px = (e.clientX - rect.left) / rect.width - 0.5;
        const py = (e.clientY - rect.top) / rect.height - 0.5;
        stage.style.transform = `rotateY(${px * 8}deg) rotateX(${py * -8}deg)`;
      });
      stage.addEventListener('mouseleave', () => {
        stage.style.transform = '';
      });
    }
  }

  document.querySelectorAll('.magnetic').forEach(btn => {
    btn.addEventListener('mousemove', (e) => {
      const rect = btn.getBoundingClientRect();
      const mx = ((e.clientX - rect.left) / rect.width) * 100;
      const my = ((e.clientY - rect.top) / rect.height) * 100;
      btn.style.setProperty('--mx', `${mx}%`);
      btn.style.setProperty('--my', `${my}%`);
      if (!prefersReducedMotion) {
        const px = (e.clientX - rect.left) / rect.width - 0.5;
        const py = (e.clientY - rect.top) / rect.height - 0.5;
        btn.style.transform = `translate(${px * 6}px, ${py * 6}px)`;
      }
    });
    btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
  });

  document.querySelectorAll('.product-card').forEach(card => {
    if (prefersReducedMotion || window.innerWidth <= 900) return;
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width - 0.5;
      const py = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = `perspective(900px) rotateY(${px * 6}deg) rotateX(${py * -6}deg) translateY(-8px)`;
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });

  const statNumbers = document.querySelectorAll('.stat-number');
  if (statNumbers.length) {
    const animateCount = (el) => {
      const target = parseFloat(el.getAttribute('data-count'));
      const decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      const suffix = el.getAttribute('data-suffix') || '';
      const duration = 1600;
      const start = performance.now();
      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const value = target * eased;
        el.textContent = value.toFixed(decimals) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      };
      if (prefersReducedMotion) {
        el.textContent = target.toFixed(decimals) + suffix;
      } else {
        requestAnimationFrame(step);
      }
    };
    const animatableStats = Array.from(statNumbers).filter(el => el.hasAttribute('data-count'));
    if ('IntersectionObserver' in window) {
      const statIo = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            statIo.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });
      animatableStats.forEach(el => statIo.observe(el));
    } else {
      animatableStats.forEach(animateCount);
    }
  }

  const loader = document.getElementById('pageLoader');
  if (loader) {
    window.addEventListener('load', () => {
      setTimeout(() => loader.classList.add('hidden'), 250);
    });
    setTimeout(() => loader.classList.add('hidden'), 1500);
  }

  const yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  const announceBar = document.getElementById('announceBar');
  const announceClose = document.getElementById('announceClose');
  if (announceBar && announceClose) {
    announceClose.addEventListener('click', () => {
      announceBar.classList.add('closed');
    });
  }

  const header = document.getElementById('siteHeader');
  const onScrollHeader = () => {
    if (window.scrollY > 12) header.classList.add('scrolled');
    else header.classList.remove('scrolled');
  };
  onScrollHeader();
  window.addEventListener('scroll', onScrollHeader, { passive: true });

  const menuButton = document.getElementById('menuButton');
  const nav = document.getElementById('nav');
  if (menuButton && nav) {
    menuButton.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('open');
      menuButton.classList.toggle('open', isOpen);
      menuButton.setAttribute('aria-expanded', String(isOpen));
    });
    nav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        nav.classList.remove('open');
        menuButton.classList.remove('open');
        menuButton.setAttribute('aria-expanded', 'false');
      });
    });
  }

  const navLinks = document.querySelectorAll('[data-nav]');
  const sections = Array.from(navLinks)
    .map(link => {
      const href = link.getAttribute('href') || '';
      return href.startsWith('#') && href.length > 1
        ? document.querySelector(href)
        : null;
    })
    .filter(Boolean);

  const setActiveLink = () => {
    if (!sections.length) return;
    let currentId = sections[0] ? sections[0].id : null;
    const scrollPos = window.scrollY + 140;
    sections.forEach(section => {
      if (section.offsetTop <= scrollPos) currentId = section.id;
    });
    navLinks.forEach(link => {
      const href = link.getAttribute('href') || '';
      if (href.startsWith('#')) {
        link.classList.toggle('active', href === `#${currentId}`);
      }
    });
  };
  setActiveLink();
  window.addEventListener('scroll', setActiveLink, { passive: true });

  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('in-view'));
  }

  const backToTop = document.getElementById('backToTop');
  if (backToTop) {
    window.addEventListener('scroll', () => {
      backToTop.classList.toggle('visible', window.scrollY > 600);
    }, { passive: true });
    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  document.querySelectorAll('.product-card[data-product-url]').forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('.pc-price-row') || e.target.closest('.pc-view')) return;
      var url = card.getAttribute('data-product-url');
      if (url) window.location.href = url;
    });
  });

});

(function () {
  const drawer = document.getElementById('cartDrawer');
  if (!drawer) return;

  const overlay = document.getElementById('cartDrawerOverlay');
  const closeBtn = document.getElementById('cartDrawerClose');
  const openBtn = document.getElementById('cartIconBtn');
  const itemsList = document.getElementById('cartDrawerItems');
  const emptyState = document.getElementById('cartDrawerEmpty');
  const footer = document.getElementById('cartDrawerFooter');
  const subtotalEl = document.getElementById('cartDrawerSubtotal');
  const countEl = document.getElementById('cartDrawerCount');
  const headerBadge = document.getElementById('cartIconBadge');
  const emptyCta = document.getElementById('cartDrawerEmptyCta');
  const viewCartBtn = document.getElementById('cartDrawerViewCart');

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return '\u00a3' + amount;
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-locked');
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-locked');
  }

  function renderCart(cart) {
    if (headerBadge) headerBadge.textContent = cart.item_count;
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';

    if (!cart.item_count) {
      if (emptyState) emptyState.hidden = false;
      if (itemsList) itemsList.hidden = true;
      if (footer) footer.hidden = true;
      if (itemsList) itemsList.innerHTML = '';
      return;
    }

    if (emptyState) emptyState.hidden = true;
    if (itemsList) itemsList.hidden = false;
    if (footer) footer.hidden = false;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (itemsList) {
      itemsList.innerHTML = cart.items.map(function (item, idx) {
        const img = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_200x$1$2') : '';
        return (
          '<li class="cart-drawer-item" data-line="' + (idx + 1) + '">' +
            '<div class="cdi-media">' + (img ? '<img src="' + img + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') + '</div>' +
            '<div class="cdi-info">' +
              '<p class="cdi-title">' + item.product_title + '</p>' +
              '<p class="cdi-variant">' + (item.variant_title || '') + '</p>' +
              '<div class="cdi-row">' +
                '<div class="cdi-qty">' +
                  '<button type="button" class="cdi-qty-btn" data-action="minus" aria-label="Decrease quantity">&minus;</button>' +
                  '<span class="cdi-qty-num">' + item.quantity + '</span>' +
                  '<button type="button" class="cdi-qty-btn" data-action="plus" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<span class="cdi-price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="cdi-remove" aria-label="Remove ' + item.product_title.replace(/"/g, '&quot;') + '">' +
              '<svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
            '</button>' +
          '</li>'
        );
      }).join('');
    }
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  if (openBtn) openBtn.addEventListener('click', function () { fetchCart(); openDrawer(); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (emptyCta) emptyCta.addEventListener('click', function () {
    closeDrawer();
    window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'collections/all';
  });
  if (viewCartBtn) viewCartBtn.addEventListener('click', function () { window.location.href = '/cart'; });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  if (itemsList) {
    itemsList.addEventListener('click', function (e) {
      const li = e.target.closest('.cart-drawer-item');
      if (!li) return;
      const line = parseInt(li.getAttribute('data-line'), 10);
      const qtyNum = li.querySelector('.cdi-qty-num');
      const currentQty = qtyNum ? parseInt(qtyNum.textContent, 10) : 1;

      if (e.target.closest('.cdi-remove')) {
        changeLine(line, 0);
      } else if (e.target.closest('[data-action="plus"]')) {
        changeLine(line, currentQty + 1);
      } else if (e.target.closest('[data-action="minus"]')) {
        changeLine(line, Math.max(0, currentQty - 1));
      }
    });
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form.matches('form[action*="/cart/add"]') || form.querySelector('button[name="add"]'))) return;
    if (!form.action || form.action.indexOf('/cart/add') === -1) {
      if (!form.querySelector('input[name="id"]')) return;
    }
    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.style.opacity = '0.7'; }

    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.style.opacity = ''; submitBtn.innerHTML = originalText; }
        fetchCart();
        openDrawer();
      })
      .catch(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.style.opacity = ''; }
      });
  });

  fetchCart();
})();

(function () {
  var confirmBtn = document.getElementById('ageGateConfirm');
  var denyBtn = document.getElementById('ageGateDeny');

  function unlock() {
    document.documentElement.classList.remove('age-gate-active');
  }

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      try { localStorage.setItem('luminaAgeVerified', 'true'); } catch (e) {}
      unlock();
    });
  }
  if (denyBtn) {
    denyBtn.addEventListener('click', function () {
      window.location.href = 'https://www.google.com';
    });
  }
})();
